// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Eyng","rootSmall":"AddTileButton_rootSmall__2wQ1A"};